import React, { useState, Fragment } from 'react';
import { useDispatch } from 'react-redux';
import { dataFormat } from '../../functions/dataFormat.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash, faTrash } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion' 
import { format } from 'date-fns';
import axios from "axios";
import { fetchMieszkancy, fetchMieszkancyAll } from '../../Redux/Actions.js';
import DialogYesNo from '../DialogYesNo.js';
import DialogOk from '../DialogOk.js';

const MieszkaniecDaneHistoriaZmian = ( props ) => {

    const { mieszkaniecAll, zmianyMieszkancaPokaz, setZmianyMieszkancaPokaz, idw } = props;
    const dispatch = useDispatch();
    const remove = id => {
        try {
            axios.post('/api/mieszkaniec/usun', {
                id: id,
            }).then( response => {
                dispatch(fetchMieszkancy(idw));
                dispatch(fetchMieszkancyAll(idw));
            })
        } catch (error) {
            console.error('Błąd podczas dodawania danych:', error);
        }
    }

    const [open1, setOpen1] = useState(false);
    const [open2, setOpen2] = useState(false);


    const handleTrash = () => mieszkaniecAll?.length > 1 ? setOpen1(true) : setOpen2(true);

    const zmiany = mieszkaniecAll?.map( (m, i) => {

        return (
            <motion.div 
                className='mieszkancyHistoria'
                key={i}
            >
                <DialogYesNo 
                    open={open1}
                    setOpen={setOpen1}
                    message={`Czy na pewno chcesz usunąć ten wpis?`}
                    f={remove}
                    id={m.id}
                />
                <DialogOk
                    open={open2}
                    setOpen={setOpen2}
                    message={`Przynajmniej jeden obiekt mieszkańca musi zostać.`}
                />
                <div className='wiersz'>
                    <div className='data'>
                        Data zmiany: {dataFormat(m.data_od)}
                    </div>
                    <div style={{textAlign: "right"}}>
                        <FontAwesomeIcon 
                            icon={faTrash} 
                            onClick={handleTrash}
                            className='pointer'
                        />
                    </div>
                </div>

                <div className='wiersz'>
                    <div>
                        Data utworzenia:
                    </div>
                    <div>
                        {format(m.data_utworzenia,'yyyy-MM-dd HH:mm:ss')}
                    </div>                 
                </div>
                <div className='wiersz'>
                    <div>
                        {m.imie_nazwisko}
                    </div>
                    <div>
                        {`${m.email}, ${m.telefon}`}
                    </div>
                </div>
                <div className='wiersz'>
                    <div>
                        {`Nota obciążeniowa: ${m.czy_nota == 1 ? "Tak" : "Brak"}`}
                    </div>
                    <div>
                        {`Czy zasiada w zarządzie: ${m.czy_zarzad == 1 ? "Tak" : "Nie"}`}
                    </div>
                </div>
                <div>
                    {`NIP: ${m.nip ? m.nip : "brak"}`}    
                </div>   
            </motion.div>
        )

    })
        
    const onClickHandle = () => setZmianyMieszkancaPokaz( prevState => !prevState);
    
    return(
        <Fragment>
            <h2 onClick={onClickHandle} className='pointer'>
                Historia zmian
                <span>
                    { zmianyMieszkancaPokaz ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} /> }
                </span>
            </h2>
            { zmianyMieszkancaPokaz && zmiany }
        </Fragment>
    )
}

export default MieszkaniecDaneHistoriaZmian;